module.exports = __webpack_public_path__ + "media/remote.467cd27c.mp4";